export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const WHATSAPP_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || "919999999999";

export const waLink = (text) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72, duration: 1.2 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const CATEGORIES = ["Flights", "Hotels", "Holiday Packages", "Buses", "Trains"];
export const PRICE_CATEGORIES = ["Flights", "Hotels", "Buses"];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1590602391458-7aaa83454938?crop=entropy&cs=srgb&fm=jpg&q=85",
  hotel: "https://images.unsplash.com/photo-1781961486926-6a8444b152c3?crop=entropy&cs=srgb&fm=jpg&q=85",
  kerala: "https://images.unsplash.com/photo-1470214203634-e436a8848e23?crop=entropy&cs=srgb&fm=jpg&q=85",
  train: "https://images.unsplash.com/photo-1661410205208-f401a7d1edc8?crop=entropy&cs=srgb&fm=jpg&q=85",
  flight: "https://images.unsplash.com/photo-1644418634481-918f39597be8?crop=entropy&cs=srgb&fm=jpg&q=85"
};
